import { DocumentHistory } from "./document-history.js";
import { notifyAndLogStandardApiError } from "../../../components-shared/utils/notify-error-reporter.js";

class DocumentsHistoryController {
    private mainContainer: HTMLElement;
    
    constructor(private _context: any) {
        this.mainContainer = document.getElementById(this._context.containerId);

        const documentHistory = new DocumentHistory({ 
            itemsPerPage: _context.documentsOnPageCount,
            rootFolderId: _context.rootFolderId,
            tagCategoriesRootId: _context.tagCategoriesRootId,
            screenshotsRelationsIDs: _context.screenshotsRelationsIDs,
            screenshotImageWidth: _context.screenshotImageWidth,
            screenshotImageModification: _context.screenshotImageModification,
            renderPageId: _context.renderPageId,
            errorReporter: notifyAndLogStandardApiError
        }, _context.labels);

        this.mainContainer.appendChild(documentHistory);
    }
}

((w: any) => {
    const assetId = "uc217-documentshistory";
    if (w.umwAssets && w.umwAssets[assetId]) {
        w.umwAssets[assetId].forEach((context: any) => {
            if (context) {
                new DocumentsHistoryController(context);
            }
        });
    }
})(window as any);